exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Styles of my dialog */\r\n#selectdialog .mat-dialog-title h3 {\r\n  color: white;\r\n  margin: 0;\r\n}\r\n#selectdialog .mat-dialog-title {\r\n  background-color: #6abbd6;\r\n  padding: 24px;\r\n  margin: 0 0 1px;\r\n  position: relative;\r\n}\r\n#selectdialog .mat-dialog-content {\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n#selectdialog .mat-list-item .mat-button {\r\n  padding: 0 32px;\r\n  width: 100%;\r\n  text-align: left;\r\n  height: 100%;\r\n  font-family: \"Lato\";\r\n  font-weight: 400;\r\n  font-size: 1em;\r\n  color: #55637f;\r\n}\r\n#selectdialog .mat-list-item-content{\r\n  padding: 0;\r\n}\r\n#selectdialog .mat-dialog-title .mat-icon-button {\r\n  color: white;\r\n  position: absolute;\r\n  right: 5px;\r\n  top: 5px;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/uriel/Documents/newspaperReporteador/src/app/components/select-repartidor-dialog/select-dialog.component.css
// module id = ../../../../../src/app/components/select-repartidor-dialog/select-dialog.component.css
// module chunks = main